"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchEvent = void 0;
const launchEvent = e => {
    // not an 'a', missing 'href' or is a hash/anchor ?
    // || link.href.indexOf('#') !== -1
    if (!e)
        return;
    const analyticsEvent = {};
    window.digitalData.component = [];
    window.digitalData.component.push({
        componentInfo: {
            componentName: e.component || 'NO COMPONENT NAME',
        },
    });
    if (typeof window.ctConstants === 'undefined')
        return;
    analyticsEvent.eventInfo = {
        type: window.ctConstants.trackEvent,
        eventAction: window.ctConstants.inputerror,
        eventLabel: `${e.label} - ${e.error}`,
        eventValue: 1,
    };
    analyticsEvent.category = {
        primaryCategory: window.ctConstants.custom,
        subcategory: 'Error',
    };
    window.digitalData.event.push(analyticsEvent);
};
exports.launchEvent = launchEvent;
